import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface DeleteDepartmentRequest {
  departmentIds: number[];
}

const useDeleteDepartmentsApi = (companyId: string) => {
  const call = useCallback(
    async (params?: DeleteDepartmentRequest) => {
      try {
        const res = await axiosInstance.post(
          api.deleteDepartment(companyId),
          params?.departmentIds
        );
        return res.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { isLoading, execute, status } = useAsync(call, false);

  return {
    isLoading,
    deleteDepartment: execute,
    deleteDepartmentStatus: status,
  };
};

export default useDeleteDepartmentsApi;
